import { useState } from 'react';
import { Link } from 'react-router-dom';

import { LegalModal, PrivacyPolicyContent, TermsOfServiceContent } from './LegalModal';

export function BrandLockup({ compact = false }: { compact?: boolean }) {
  return (
    <span className={`r42-marketing-brand${compact ? ' r42-marketing-brand--compact' : ''}`}>
      <img src="/brand/route42-lockup-white-text.png" alt="Route42" width={1730} height={364} />
    </span>
  );
}

export function MarketingHeader({ onRequestAccess }: { onRequestAccess: () => void }) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  function closeMobileMenu() {
    setMobileMenuOpen(false);
  }

  function requestAccess() {
    closeMobileMenu();
    onRequestAccess();
  }

  return (
    <header className={`r42-marketing-header${mobileMenuOpen ? ' r42-marketing-header--menu-open' : ''}`}>
      <Link className="r42-marketing-home-link" to="/" aria-label="Route42 home" onClick={closeMobileMenu}>
        <BrandLockup />
      </Link>
      <button
        className="r42-marketing-menu-toggle"
        type="button"
        aria-label={mobileMenuOpen ? 'Close navigation menu' : 'Open navigation menu'}
        aria-controls="route42-marketing-navigation"
        aria-expanded={mobileMenuOpen}
        onClick={() => setMobileMenuOpen((open) => !open)}
      >
        <i className={`bi ${mobileMenuOpen ? 'bi-x-lg' : 'bi-list'}`} aria-hidden="true" />
      </button>
      <nav
        id="route42-marketing-navigation"
        className={`r42-marketing-nav${mobileMenuOpen ? ' r42-marketing-nav--open' : ''}`}
        aria-label="Primary navigation"
      >
        <Link to="/#intelligence-layer" onClick={closeMobileMenu}>Product</Link>
        <Link to="/how-route42-works" onClick={closeMobileMenu}>How Route42 Works</Link>
        <Link to="/company" onClick={closeMobileMenu}>Company</Link>
        {/* Sign in intentionally de-emphasized during the Route42 Pivot launch phase. */}
        <button className="r42-marketing-nav-cta" type="button" onClick={requestAccess}>Request access</button>
      </nav>
    </header>
  );
}

export function MarketingFooter() {
  const [legalDocument, setLegalDocument] = useState<'terms' | 'privacy' | null>(null);

  return (
    <>
      <footer className="r42-marketing-footer">
        <BrandLockup compact />
        <nav aria-label="Footer navigation">
          <Link to="/#intelligence-layer">Product</Link>
          <Link to="/how-route42-works">How Route42 Works</Link>
          <Link to="/company">Company</Link>
          <Link to="/design-partners">Design Partners</Link>
          {/* Security link intentionally deferred during the Route42 Pivot launch phase. */}
        </nav>
        <div className="r42-marketing-footer-right">
          <span>© 2026 Route42. All rights reserved.</span>
          <div className="r42-marketing-footer-legal" aria-label="Legal">
            <button type="button" onClick={() => setLegalDocument('terms')}>Terms of Service</button>
            <button type="button" onClick={() => setLegalDocument('privacy')}>Privacy Policy</button>
          </div>
        </div>
      </footer>

      <LegalModal
        open={legalDocument === 'terms'}
        title="Route42 Terms of Service"
        lastUpdated="August 25, 2025"
        onClose={() => setLegalDocument(null)}
      >
        <TermsOfServiceContent />
      </LegalModal>

      <LegalModal
        open={legalDocument === 'privacy'}
        title="Route42 Privacy Policy"
        lastUpdated="August 25, 2026"
        onClose={() => setLegalDocument(null)}
      >
        <PrivacyPolicyContent />
      </LegalModal>
    </>
  );
}
